import { humanizeString } from '@chillibean/component-library';
import { capitalize } from 'lodash';

export const handleFieldError = (requestError, field) => {
  if (!requestError?.data?.errors?.fields?.[field]) return undefined;

  const humanizedField = capitalize(humanizeString(field));
  const humanizedErrors = requestError?.data?.errors?.fields?.[field].join(', ');
  return `${humanizedField} ${humanizedErrors}`;
};

export const handleToastError = (requestError, displayErrorCallback) => {
  if (!requestError.status || requestError?.data?.errors?.fields) return undefined;

  return displayErrorCallback({
    message: `${requestError?.status.toString()}: ${requestError?.data?.errors?.message}`,
  });
};
